export default "__VITE_ASSET__c4aa1a58__"